<template>
    <div class="income-compare-table__box box">
        <table class="income-compare-table__table income-compare-table__table_striped income-compare-table__table_hover">
            <caption class="income-compare-table__caption"
                v-if="reportRow.caption"
            >
                <template v-if="reportRow.link">
                    <router-link class="link link_red"
                        :to="reportRow.link.to"
                        :title="reportRow.link.title"
                    >
                        {{reportRow.caption}}
                    </router-link>
                </template>
                <template v-else>{{reportRow.caption}}</template>
            </caption>
            <col class="income-compare-table__column"
                v-for="column in columns"
                :key="column.id"
                :class="`income-compare-table__column_${column.id}`"
            >
            <thead>
                <tr class="income-compare-table__row income-compare-table__row_head">
                    <th class="income-compare-table__cell income-compare-table__cell_head" scope="col"
                        v-for="column in columns"
                        :key="column.id"
                    >
                        <div class="income-compare-table__cell-content income-compare-table__cell-content_columns"
                            :class="`income-compare-table__cell-content_${column.alignment}`"
                        >
                            <span class="income-compare-table__value">
                                <template v-if="column.id === 'prediction'">Прогноз выручки<br></template>
                                {{column.title}}
                            </span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="income-compare-table__row income-compare-table__row_body">
                    <td class="income-compare-table__cell"
                        v-for="column in columns"
                        :key="column.id"
                        :class="{ 'income-compare-table__cell_title': column.id === 'title' }"
                    >
                        <div class="income-compare-table__cell-content income-compare-table__cell-content_rows"
                            :class="`income-compare-table__cell-content_${column.alignment}`"
                        >
                            <span class="income-compare-table__value">
                                {{format(column, reportRow)}}
                            </span>
                            <difference v-if="column.difference && compareRow[column.id]"
                                 class="income-compare-table__value"
                                :primaryValue="reportRow[column.id]"
                                :compareValue="compareRow[column.id]"
                                mode="percentage"
                                :good="column.difference.good"
                                filter="percentFloatFormat"
                            />
                        </div>
                    </td>
                </tr>
                <tr class="income-compare-table__row income-compare-table__row_body">
                    <td class="income-compare-table__cell"
                        v-for="column in columns"
                        :key="column.id"
                        :class="{ 'income-compare-table__cell_title': column.id === 'title' }"
                    >
                        <div class="income-compare-table__cell-content income-compare-table__cell-content_rows"
                            :class="`income-compare-table__cell-content_${column.alignment}`"
                        >
                            <span class="income-compare-table__value">
                                <template v-if="compareRow.hasOwnProperty(column.id)">{{format(column, compareRow)}}</template>
                                <template v-else>нет данных</template>
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import Difference from "@/components/Difference";

    export default {
        name: "IncomeCompareTable",
        components: {
            Difference,
        },
        props: {
            columns: {
                type: Array,
                required: true
            },
            reportRow: {
                type: Object,
                required: true
            },
            compareRow: {
                type: Object,
                required: true
            }
        },
        methods: {
            format(column, row) {
                if (!this.$options.filters[column.filter]) {
                    return row[column.id];
                }

                return this.$options.filters[column.filter](row[column.id]);
            }
        },
    };
</script>

<style lang="scss">
    .income-compare-table__box {
        padding: 16px;
        overflow-x: auto;
    }
    .income-compare-table__table {
        width: 100%;
    }
    .income-compare-table__caption {
        padding: 8px;
        font-size: 24px;
        font-weight: bold;
    }
    .income-compare-table__row {
        &_body {
            .income-compare-table__table_striped &:nth-of-type(odd) {
                background-color: $background-gray-primary;
            }

            .income-compare-table__table_hover &:hover {
                background-color: $gray-form;
            }
        }

        &_pinned {
            background-color: $gray-form !important;
        }
    }
    .income-compare-table__cell {
        font-size: 20px;
        padding: 12px 8px;

        &_head {
            padding: 8px;
            white-space: nowrap;
        }

        &_sortable {
            cursor: pointer;
        }

        &_title {
            font-weight: bold;
        }

        &_tar {
            text-align: right;
        }
    }
    .income-compare-table__cell-content {
        display: grid;
        grid-gap: 5px;

        &_columns {
            grid-auto-flow: column;
            align-items: center;

            &.income-compare-table__cell-content_left {
                justify-content: start;
            }

            &.income-compare-table__cell-content_right {
                justify-content: end;
                text-align: right;
            }
        }

        &_rows {
            grid-auto-flow: row;

            &.income-compare-table__cell-content_left {
                justify-items: start;
            }

            &.income-compare-table__cell-content_right {
                justify-items: end;
            }
        }
    }
    .income-compare-table__value {
        &_icon {
            width: 16px;
            height: 16px;
        }
    }
</style>
